import Vue from 'vue';
import { Inject } from 'vue-property-decorator';

import { PROVIDER_PAGE_CONTENT } from '../utils/providers';

export const InjectPageContent: () => PropertyDecorator = () => (target, key) => {
  Inject(PROVIDER_PAGE_CONTENT)(target as Vue, key as string);
};
